import { dataLayerPush } from '@/shared/analytics';

export function useManageSubscriptionAnalytics() {
    function send() {
        dataLayerPush({ event: 'manage_subscription', site_section: 'pdp' });
    }

    return { send };
}
